import React, { PropTypes } from "react";

import * as actions from "../actions/actions";
import { connect } from "react-redux";

import InfoBar from "../components/infobar";

let get_parameter_by_name = require("../legacy/helpers/get_parameter_by_name")
    .default;

class SearchInfoBarContainer extends React.Component {
    static propTypes = {
        query: PropTypes.string,
        searchType: PropTypes.string,
        didYouMean: PropTypes.string
    };

    render() {
        return (
            <InfoBar
                query={this.props.query}
                searchType={this.props.searchType}
                didYouMean={this.props.didYouMean}
                store={this.props.store}
            />
        );
    }
}

function mapStateToProps(state, ownProps) {
    let creator, collection, query, result_type, did_you_mean, scope;
    if (state.search.queryInfo) {
        query = state.search.queryInfo.query;
        result_type = state.search.queryInfo.result_type;
        creator = new Object();
        collection = new Object();
        creator = state.search.queryInfo.creator;
        collection = state.search.queryInfo.collection;
        did_you_mean = state.search.queryInfo.did_you_mean;
        scope = state.search.queryInfo.scope;
    } else {
        query = ownProps.query;
    }
    return { creator, collection, query, result_type, did_you_mean, scope };
}

module.exports = connect(mapStateToProps, {})(SearchInfoBarContainer);
